// Centralized color utilities for node types across views
// Use MUI theme to keep colors consistent with the design system

import { Theme } from '@mui/material/styles';

export const getNodeTypeColor = (nodeType: string, theme: Theme): string => {
  switch (nodeType) {
    case 'System':
      return theme.palette.primary.main;
    case 'TechnologyType':
      // Central definition for TechnologyType
      return theme.palette.secondary.main;
    case 'Material':
      return theme.palette.warning.main;
    case 'HSCode':
      return theme.palette.info.main;
    default:
      return theme.palette.grey[500];
  }
};

export const getTechnologyTypeColor = (theme: Theme): string => theme.palette.secondary.main;

// Company layer colors: 0..N mapped to theme palette to keep harmony across the app
// Order chosen to maximize contrast and align with existing node colors
export const getCompanyLayerColor = (theme: Theme, layer: number): string => {
  const palette = [
    // Root (layer 0) should be reddish tone
    theme.palette.error.main,
    theme.palette.success.main,
    theme.palette.warning.main,
    theme.palette.info.main,
    theme.palette.secondary.main,
    theme.palette.primary.main,
  ];
  const idx = Math.max(0, layer) % palette.length;
  return palette[idx];
};


